export function AccessPrevilegesFunction(previlage) {
    const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.PRIVILAGES || [];
    return currentUserPrevilages.includes(previlage);
}
